export default __webpack_public_path__ + "static/media/fb_icon.13fad525.svg";